<template>
  <div class="relevance">
    <p class="relevance_text">电巢账户是您学习交流的通行证</p>

    <div class="relevance_con">
      <input class="app_relevance" type="text" placeholder="请输入电巢账号" v-model="account" @input="accountInput">
      <p class="condition" :class="{valid: rule.valid}" v-for="(rule, index) of accountRule" :key="index">
        <span class="dot"></span>
        {{rule.title}}
      </p>
    </div>

    <div class="relevance_con">
      <div class="app_password">
        <input :type="inputType" placeholder="请输入密码" v-model="password" maxlength="18" @input="passwordInput">
        <div @click="showPaassword">
          <img src="@/assets/image/course/look_icon.png" alt="">
        </div>
      </div>
      <p class="condition" :class="{valid: rule.valid}" v-for="(rule, index) of passwordRule" :key="index">
        <span class="dot"></span>
        {{rule.title}}
      </p>
    </div>

    <div class="bottomArea">
      <div class="yes_btn" :class="{btnInvalid: !validCheck}" @click="confirm">
        <p>确 定</p>
      </div>
			<div class="bottom">
				<p>未注册的用户我们将会自动为您创建账户</p>
			</div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'

  export default {
    data() {
      return {
        account: '',
        password: '',
        inputType: 'password',
        accountRule: [{
          title: '长度小于16个字符',
          valid: false,
          check: function(val){
            return val.length > 0 && val.length <= 16
          }
        },{
          title: '不含特殊字符',
          valid: false,
          check: function(val){
            var reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/g
            return reg.test(val)
          }
        }],
        passwordRule: [{
          title: '长度6-18位',
          valid: false,
          check: function(val){
            return val.length >= 6 && val.length <= 18
          }
        },{
          title: '包含字母',
          valid: false,
          check: function(val){
            var reg = /[a-zA-Z]+/g
            return reg.test(val)
          }
        },{
          title: '包含数字',
          valid: false,
          check: function(val){
            var reg = /[0-9]+/g
            return reg.test(val)
          }
        }]
      }
    },
    inject: ['commonData'],
    computed: {
      validCheck(){
        let rules = [...this.accountRule, ...this.passwordRule]
        for(let rule of rules){
          if(!rule.valid){
            return false
          }
        }
        return true
      }
    },
    methods: {
      accountInput(e){
        let value = e.target.value
        this.accountRule.forEach(rule => {
          rule.valid = rule.check(value)
        })
        this.accountRule = [...this.accountRule]
      },
      passwordInput(e){
        let value = e.target.value
        this.passwordRule.forEach(rule => {
          rule.valid = rule.check(value)
        })
        this.passwordRule = [...this.passwordRule]
      },
      showPaassword(){
        this.inputType = 'text'
      },
      confirm(){
        if(this.validCheck){
          let body = {
            phone_head: 86,
            phone: this.commonData.phone,
            sms_code: this.commonData.smsCode,
            username: this.account,
            password: this.password,
            mp_openid: this.commonData.openid,
            source: 'H5',
            buy_together_id: this.commonData.togetherId || '',
            timestamp: new Date().getTime()/1000,
            nonce: `${ Math.random().toString().slice(2) }${ this.account }`
          }
          Object.assign(body, {sign: utils.loginSign(body)})
          this.$http.get('/Registered/wxRegister', {
            params: body
          }).then(res => {
            if(res.code >= 0){
              this.$emit('login', res.data)
            }else{
              utils.showMessage(res.msg)
            }
          })
        }
      },
      linkOutTo(url){
        this.$emit('linkOutTo', url)
      }
    }
  }
</script>

<style lang="css" scoped>
input {
  border: none;
  outline: none;
}

.relevance {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #FFFFFF;
  padding: 0 3.6rem;
}

.relevance_text {
  text-align: center;
  font-size: 1.6rem;
  font-weight: bolder;
  color: #1D2023;
  margin-top: 6.55rem;
}

.relevance_con {
  box-sizing: border-box;
  width: 100%;
}

.app_relevance {
  margin-top: 2.75rem;
  box-sizing: border-box;
  width: 100%;
  height: 4.5rem;
  background-color: #f2f4f5;
  border-radius: 2.25rem;
  font-size: 1.6rem;
  padding: 0 1.6rem;
}

.condition {
  display: flex;
  align-items: center;
  color: #C0C4CC;
  margin-top: 1rem;
}
.valid {
  color: #1ecb6c;
}

.dot {
  width: .8rem;
  height: .8rem;
  background-color: #C0C4CC;
  border-radius: .4rem;
  margin-right: .8rem;
}

.app_password {
  display: flex;
  margin-top: 2.75rem;
}

.app_password input {
  box-sizing: border-box;
  width: 85%;
  height: 4.5rem;
  background-color: #f2f4f5;
  border-radius: 2.25rem 0 0 2.25rem;
  font-size: 1.6rem;
  padding: 0 1.6rem;
}

.app_password div {
  box-sizing: border-box;
  width: 15%;
  height: 4.5rem;
  background-color: #f2f4f5;
  border-radius: 0 2.25rem 2.25rem 0;
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.app_password img {
  height: 2.4rem;
  margin-left: .4rem;
}

.bottomArea{
  margin-top: 3rem;
}
.yes_btn {
  display: flex;
  justify-content: center;
}
.yes_btn p {
  width: 30rem;
  height: 4.5rem;
  line-height: 4.5rem;
  text-align: center;
  color: #FFFFFF;
  font-size: 1.8rem;
  font-weight: bolder;
  border-radius: 4.5rem;
  background-color: #E50101;
}
.btnInvalid p {
  background-color: #c1c3c3;
}
.bottom {
  margin-top: 15px;
  text-align: center;
  font-size: 1.2rem;
  color: #808598;
}
.link{
  color: #007eff;
}
</style>
